import { TourType } from "./TourGuideContext";

const TOUR_KEY = (tour: TourType) => `app-tour-${tour}-v1`;

export type StoredTour = {
  completed: boolean;
  completedAt?: number;
};

export const loadTour = (tour: TourType): StoredTour => {
  try {
    const raw = localStorage.getItem(TOUR_KEY(tour));
    if (!raw) return { completed: false };
    return JSON.parse(raw);
  } catch {
    return { completed: false };
  }
};

export const completeTour = (tour: TourType) => {
  if (!tour) return;
  localStorage.setItem(
    TOUR_KEY(tour),
    JSON.stringify({ completed: true, completedAt: Date.now() })
  );
};


export const resetTour = (tour: TourType) => {
  localStorage.removeItem(TOUR_KEY(tour));
};
